import React, {useEffect, useState} from 'react';
import * as style from './adminStyles';

const API_BASE = '/api';

export default function ImageManager({onClose, onPick}) {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [busyName, setBusyName] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/images.php`, {credentials: 'include'})
            .then((res) => res.json())
            .then(setImages)
            .catch(() => setError('Bilder konnten nicht geladen werden.'))
            .finally(() => setLoading(false));
    }, []);

    const handleDelete = async (img) => {
        const warning = img.inUse
            ? `"${img.name}" wird noch in einem Projekt verwendet. Trotzdem löschen?`
            : `"${img.name}" wirklich löschen?`;
        if (!window.confirm(warning)) return;

        setBusyName(img.name);
        setError('');
        try {
            const res = await fetch(`${API_BASE}/delete_image.php`, {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({name: img.name}),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || !data.ok) throw new Error(data.error || 'Löschen fehlgeschlagen.');
            setImages((list) => list.filter((i) => i.name !== img.name));
        } catch (err) {
            setError(err.message || 'Löschen fehlgeschlagen.');
        } finally {
            setBusyName(null);
        }
    };

    return (
        <div style={style.overlayStyle} onClick={onClose}>
            <div style={style.panelStyle} onClick={(e) => e.stopPropagation()}>
                <div style={style.headerStyle}>
                    <h2 style={{margin: 0, fontSize: '20px'}}>Hochgeladene Bilder</h2>
                    <button type="button" onClick={onClose} style={style.button}>Schließen</button>
                </div>

                {error && <p style={{color: '#c0392b'}}>{error}</p>}
                {loading && <p style={{color: '#777'}}>Lädt…</p>}
                {!loading && images.length === 0 && (
                    <p style={{color: '#777'}}>Noch keine Bilder hochgeladen.</p>
                )}

                <div style={style.gridStyle}>
                    {images.map((img) => (
                        <div key={img.name} style={style.cardStyle}>
                            <img src={img.url} alt={img.name} style={style.thumbStyle}
                                 onError={(e) => {
                                     e.currentTarget.style.display = 'none';
                                 }}
                            />

                            {img.inUse && <span style={style.badgeStyle}>in Verwendung</span>}
                            <div style={{display: 'flex', gap: '6px', marginTop: '8px'}}>
                                {onPick && (
                                    <button
                                        type="button"
                                        style={{...style.button, flex: 1, fontSize: '12px', padding: '6px 10px'}}
                                        onClick={() => onPick(img.url)}
                                    >
                                        Übernehmen
                                    </button>
                                )}
                                <button
                                    type="button"
                                    style={{...style.button, fontSize: '12px', padding: '6px 10px'}}
                                    onClick={() => handleDelete(img)}
                                    disabled={busyName === img.name}
                                >
                                    {busyName === img.name ? '…' : 'Löschen'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
